import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface MedicationState {
  shouldRefetch: boolean;
}

const initialState: MedicationState = {
  shouldRefetch: false,
};

const medicationSlice = createSlice({
  name: "medication",
  initialState,
  reducers: {
    triggerRefetch: (state) => {
      state.shouldRefetch = true;
    },
    resetRefetch: (state) => {
      state.shouldRefetch = false;
    },
  },
});

export const { triggerRefetch, resetRefetch } = medicationSlice.actions;

export default medicationSlice.reducer;
